export const VALIDATION_MESSAGES = {
    ID: 'Необходимо указать верный ID',
    NAME: 'Имя должно состоять минимум из 3 символов',
    EMAIL: 'Email введён неверно',
    PASSWORD: 'Пароль должен состоять минимум из 6 символов',
    PHONE: 'Телефон заполнен неверно',
    DATE: 'Введите дату в формате ДД.ММ.ГГГГ',
    ABOUT: 'Описание должно состоять минимум из 15 символов',
    ABOUT_MAX: 'Описание должно состоять максимум из 200 символов',
    CITY: 'Город должен состоять минимум из 3 символов',
    CITY_MAX: 'Город должен состоять максимум из 50 символов',
    ROLE: 'Роли не существует',
    SCHOOL_CLASS: 'Класс должен быть числом от 1 до 11',
    PHOTO: 'Не корректная ссылка для фото',
}
